/* eslint-disable max-len */
import { Component, OnInit, AfterContentInit, inject } from '@angular/core';

import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';


import { MainDashboardInterface } from '../../models';
import { CreateDspService } from '../../services';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-create-dsp-dialog',
  templateUrl: './create-dsp-dialog.component.html',
  styleUrls: ['./create-dsp-dialog.component.scss'],
  standalone: false
})
export class CreateDspDialogComponent implements OnInit, AfterContentInit {
  public data = inject(NZ_MODAL_DATA) as MainDashboardInterface.ICreateDspDialog;

  protected contentHeight = 'auto';
  protected macrosListContentHeight = 'auto';
  protected macrosListBodyHeight = 'auto';
  protected customSchainSettingsModalWidth = 'auto';

  protected androidTooltipUrl = 'https://play.google.com/store/apps/details?id=${app.bundle}';
  protected iosTooltipUrl = 'https://itunes.apple.com/app/id${app.bundle}';

  protected mraidTooltip = '"Exclude mraid.js responses" filter: mraid.js is contained in the ADM in the DSP response';

  constructor(
    protected createDspService: CreateDspService,
    private dialogRef: NzModalRef<CreateDspDialogComponent>,
  ) { }

  public ngOnInit(): void {
    this.createDspService.initializeComponent(this.data);

    window.addEventListener('storage', e => {
      if (e.key === 'NODE_ORDER_UPDATE') {
        const stored = localStorage.getItem('NODE_ORDER_UPDATE');
        this.createDspService.schainNodeOrderItems = stored ? JSON.parse(stored) : [];
      }
    });

    (this.newDSPForm.get('isSspSchain') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeSSPSchainStatusHandler(value);
    });

    (this.newDSPForm.get('sChain') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangePlatformSchainStatusHandler(value);
    });

    (this.newDSPForm.get('schain_source') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeDSPSourceSchainStatusHandler(value);
    });

    (this.newDSPForm.get('is_ssp_schain_source') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeSSPSourceSchainStatusHandler(value);
    });

    (this.newDSPForm.get('video') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeVideoFormatHandler(value);
    });

    (this.newDSPForm.get('banner') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeBannerFormatHandler(value);
    });

    (this.newDSPForm.get('native') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeNativeHandler(value);
    });

    (this.newDSPForm.get('rewarded') as FormControl).valueChanges.subscribe(value => {
      this.createDspService.onChangeRewardedVideoFormatHandler(value);
    });

    (this.newDSPForm.get('connectionType') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeConnectionTypeHandler(value);
    });

    (this.newDSPForm.get('deviceIdRequired') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeOnlyWithIFAHandler(value);
    });

    (this.newDSPForm.get('pixalate_pb_settings')?.get('ip') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangePixalatePreBidIpHandler(value);
    });

    (this.newDSPForm.get('pixalate_pb_settings')?.get('ifa') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangePixalatePreBidIFAHandler(value);
    });

    (this.newDSPForm.get('pixalate_pb_settings')?.get('hr_app') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangePixalatePreBidBundleHandler(value);
    });

    (this.newDSPForm.get('is_lmt_and_dnt_filter') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeLMTAndDNTFilterHandler(value);
    });

    (this.newDSPForm.get('schainCompany') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeSchainCompanyHandler(value);
    });

    (this.newDSPForm.get('schain_node_order') as FormControl).valueChanges.subscribe((value) => {
      if (value === null) {
        return;
      }

      this.createDspService.onChangeSchainNodeOrderHandler(value, this.customSchainSettingsModalWidth);
    });

    (this.newDSPForm.get('presetPlayerSizes')?.get('size') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeVideoWidthPresetsHandler(value);
    });

    (this.newDSPForm.get('playerSizes')?.get('size') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onChangeVideoSizesHandler(value);
    });

    (this.newDSPForm.get('region') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onEndpointRegionChangeHandler(value);
    });

    (this.newDSPForm.get('is_only_with_consent') as FormControl).valueChanges.subscribe((value) => {
      this.createDspService.onShowConsentConfirmModalHandler(value);
    });
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 132 + 'px';
    this.macrosListContentHeight = window.innerHeight - 200 + 'px';
    this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
    this.customSchainSettingsModalWidth = window.innerWidth - 800 + 'px';
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 132 + 'px';
      this.macrosListContentHeight = window.innerHeight - 200 + 'px';
      this.macrosListBodyHeight = window.innerHeight - 250 + 'px';
      this.customSchainSettingsModalWidth = window.innerWidth - 800 + 'px';
    });
  }

  protected get isBotmanPostBidIsEnabled(): boolean {
    return this.createDspService.isBotmanPostBidIsEnabled();
  }

  protected isHumanFraudsensorEnabled(): boolean {
    return this.createDspService.isHumanFraudsensorEnabled();
  }

  protected isFraudLogixEnabled(): boolean {
    return this.createDspService.isFraudLogixEnabled();
  }

  protected get isShowCustomSchainFilters(): boolean {
    return this.createDspService.isShowCustomSchainFilters;
  }

  protected get newDSPForm(): FormGroup {
    return this.createDspService.newDSPForm;
  }

  protected isRequiredAdapterField(itemName: string): boolean {
    return this.createDspService.getIsRequiredAdapterField(itemName);
  }

  protected onChangeQPSAdapter(value: boolean): void {
    this.createDspService.onChangeQPSAdapterHandler(value);
  }

  protected changeEndpointActive(event: boolean): void {
    this.createDspService.onChangeEndpointActiveHandler(event);
  }

  protected onAddSizeItem(input: HTMLInputElement, array: any[]): void {
    this.createDspService.onAddSizeItemHandler(input, array);
  }

  protected enterSize(event: KeyboardEvent): void {
    this.createDspService.onEnterSizeHandler(event);
  }

  protected onChangeCheckedTCF(value: boolean): void {
    this.createDspService.onChangeCheckedTCFHandler(value);
  }

  protected getDynamicNameForField(name: string | number): string {
    return name as string;
  }

  protected onCompanyChange(val: number): void {
    this.createDspService.onCompanyChangeHandler(val);
  }

  protected onChangeInput(event: Event): void {
    this.createDspService.onChangePreBidFieldHandler(event);
  }

  protected onChangeRtbAdapterField(event: Event, field: string | number, name: string): void {
    this.createDspService.onChangeRtbAdapterFieldHandler(event, field, name);
  }

  protected onFormSubmit() {
    this.createDspService.onSubmitFormHandler(() => this.dialogRef.close('created'));
  }

  protected onCancel(): void {
    this.createDspService.onCloseModalHandler(() => this.dialogRef.close('cancel'));
  }

  protected async onApiLinkTest(link: string, e: Event): Promise<boolean> {
    return await this.createDspService.onApiLinkTestHandler(link, e);
  }

  protected validateLink(link: string, event: Event) {
    this.createDspService.onValidateLinkHandler(link, event);
  }

  protected getError(value: boolean): void {
    this.createDspService.onGetErrorHandler(value);
  }

  protected preventInput(event: Event, field: string): void {
    this.createDspService.onPreventInputHandler(event, field);
  }

  protected onChangeAdType() {
    this.createDspService.onChangeAdTypeHandler();
  }

  protected onChangePreBidServer(server: string): void {
    this.createDspService.onChangePreBidServerHandler(server);
  }

  protected onChangeCustomAdapters(server: string | number): void {
    this.createDspService.onChangeCustomAdaptersHandler(server);
  }

  protected showMacrosList() {
    this.createDspService.onShowMacrosListHandler(this.macrosListContentHeight, this.macrosListBodyHeight);
  }

  protected onChangeSize(id: number): void {
    this.createDspService.onChangeSizeHandler(id);
  }

  protected isDisabledOption(adapterName: string): boolean {
    return this.createDspService.getIsDisabledOption(adapterName);
  }

  protected keyPressAlphanumeric() {
    this.createDspService.onChangeNameHandler();
  }

  protected changeMarginType(type: string): void {
    this.createDspService.onChangeMarginTypeHandler(type);
  }

  protected getTooltipTitle(order: any): string {
    return `To activate this option, please fill in the "${order.name}" value for the selected Custom Schain in Custom Schain Settings. You'll be redirected to the edit screen to complete it. Saving the endpoint will not be possible until the required SID is added.`;
  }

  protected onEndpointUrlTest(endpointUrl: string, event: MouseEvent): void {
    this.createDspService.onEndpointUrlTestHandler(endpointUrl, event);
  }
}
